const currency = `(VND)`;
const currencyEn = `(VND)`;

const support = {
  hotline: `+84 983 070481`,
  phonesupport: `+84-28 38100888`,
  emailsupport: `dfvn_cs@daiichilife.com.vn`,
  Ext: `5555`,
};

const versionApp = {
  chplayID: 'vn.com.daiichilife.itrust',
  appStoreLocale: 'vn',
  appName: 'iTRUST',
  appStoreID: '1634784795',
  number: 13,
};

const notification = {
  channelId: `fcm_fallback_notification_channel`,
  channelName: `fcm_fallback_notification_channel`,
  channelDescription: `fcm_fallback_notification_channel`,
};

const gender = {
  nam: 1,
  nu: 0,
};

const riskAssessment = [
  {
    id: 'experienceInvestment',
    content: `1. Tôi muốn tiền của mình an toàn hơn là mạo hiểm.`,
    contentEn: `1. I prefer my money being safe rather than being risky.`,
    data: [
      {
        id: 1,
        name: `Hoàn toàn đồng ý`,
        nameEn: `Totally agreed`,
      },
      {
        id: 2,
        name: `Đồng ý một phần`,
        nameEn: `Partially agreed`,
      },
      {
        id: 3,
        name: `Hoàn toàn không đồng ý`,
        nameEn: `Totally disagreed`,
      },
    ],
  },
  {
    id: 'totalAsset',
    content: `2. Khoản đầu tư này chiếm bao nhiêu % trong tổng tài sản của Tôi?`,
    contentEn: `How many percentages does this investment account for my total asset?`,
    data: [
      {
        id: 1,
        name: `Dưới 10%`,
        nameEn: `Under 10%`,
      },
      {
        id: 2,
        name: `10% - 30%`,
        nameEn: `10% - 30%`,
      },
      {
        id: 3,
        name: `Trên 30%`,
        nameEn: `Over 30%`,
      },
    ],
  },
  {
    id: 'holdingTime',
    content: `3. Tôi sẽ nắm giữ khoản đầu tư này trong bao lâu?`,
    contentEn: `How long will I hold this investment?`,
    data: [
      {
        id: 1,
        name: `Trên 5 năm`,
        nameEn: `More than 5 years`,
      },
      {
        id: 2,
        name: `Từ 1 – 3 năm`,
        nameEn: `1 – 3 years`,
      },
      {
        id: 3,
        name: `Dưới 1 năm`,
        nameEn: `Less than 1 year`,
      },
    ],
  },
  {
    id: 'realized',
    content: `4. Mức biến động mà Tôi có thể chấp nhận trong một thời gian ngắn?`,
    contentEn: `How fluctuated from investments could I accept in short - term?`,
    data: [
      {
        id: 1,
        name: `Dưới 10%`,
        nameEn: `Under 10%`,
      },
      {
        id: 2,
        name: `10% - 20%`,
        nameEn: `10% - 20%`,
      },
      {
        id: 3,
        name: `20% - 50%`,
        nameEn: `20% - 50%`,
      },
    ],
  },
  {
    id: 'requirement',
    content: `5. Tôi muốn đầu tư một số tiền nhỏ một cách đều đặn`,
    contentEn: `I prefer to invest a little amount of money, frequently.`,
    data: [
      {
        id: 1,
        name: `Hoàn toàn đồng ý`,
        nameEn: `Totally agreed`,
      },
      {
        id: 2,
        name: `Đồng ý một phần`,
        nameEn: `Partially agreed`,
      },
      {
        id: 3,
        name: `Hoàn toàn không đồng ý`,
        nameEn: `Totally disagreed`,
      },
    ],
  },
];

const riskAssessmentEn = [
  {
    id: 'experienceInvestment',
    content: `1. I prefer my money being safe rather than being risky.`,
    contentEn: `1. I prefer my money being safe rather than being risky.`,
    data: [
      {
        id: 1,
        name: `Totally agreed`,
        nameEn: `Totally agreed`,
      },
      {
        id: 2,
        name: `Partially agreed`,
        nameEn: `Partially agreed`,
      },
      {
        id: 3,
        name: `Totally disagreed`,
        nameEn: `Totally disagreed`,
      },
    ],
  },
  {
    id: 'totalAsset',
    content: `2. How many percentages does this investment account for my total asset?`,
    contentEn: `2. How many percentages does this investment account for my total asset?`,
    data: [
      {
        id: 1,
        name: `Under 10%`,
        nameEn: `Under 10%`,
      },
      {
        id: 2,
        name: `10% - 30%`,
        nameEn: `10% - 30%`,
      },
      {
        id: 3,
        name: `Over 30%`,
        nameEn: `Over 30%`,
      },
    ],
  },
  {
    id: 'holdingTime',
    content: `3. How long will I hold this investment?`,
    contentEn: `3. How long will I hold this investment?`,
    data: [
      {
        id: 1,
        name: `More than 5 years`,
        nameEn: `More than 5 years`,
      },
      {
        id: 2,
        name: `1 – 3 years`,
        nameEn: `1 – 3 years`,
      },
      {
        id: 3,
        name: `Less than 1 year`,
        nameEn: `Less than 1 year`,
      },
    ],
  },
  {
    id: 'realized',
    content: `4. How fluctuated from investments could I accept in short - term?`,
    contentEn: `4. How fluctuated from investments could I accept in short - term?`,
    data: [
      {
        id: 1,
        name: `Under 10%`,
        nameEn: `Under 10%`,
      },
      {
        id: 2,
        name: `10% - 20%`,
        nameEn: `10% - 20%`,
      },
      {
        id: 3,
        name: `20% - 50%`,
        nameEn: `20% - 50%`,
      },
    ],
  },
  {
    id: 'requirement',
    content: `5. I prefer to invest a little amount of money, frequently.`,
    contentEn: `5. I prefer to invest a little amount of money, frequently.`,
    data: [
      {
        id: 1,
        name: `Totally agreed`,
        nameEn: `Totally agreed`,
      },
      {
        id: 2,
        name: `Partially agreed`,
        nameEn: `Partially agreed`,
      },
      {
        id: 3,
        name: `Totally disagreed`,
        nameEn: `Totally disagreed`,
      },
    ],
  },
];

const monthlyIncom = [
  {
    id: `1`,
    name: `< 30,000,000 ${currency}`,
    nameEn: `< 30,000,000 ${currency}`,
  },
  {
    id: `2`,
    name: `30,000,000 VND - 80,000,000 ${currency}`,
    nameEn: `30,000,000 VND - 80,000,000 ${currency}`,
  },
  {
    id: `3`,
    name: `81,000,000 VND - 150,000,000 ${currency}`,
    nameEn: `81,000,000 VND - 150,000,000 ${currency}`,
  },
  {
    id: `4`,
    name: `> 150,000,000 ${currency}`,
    nameEn: `> 150,000,000 ${currency}`,
  },
];

const monthlyIncomEn = [
  {
    id: `1`,
    name: `< 30,000,000 ${currencyEn}`,
    nameEn: `< 30,000,000 ${currencyEn}`,
  },
  {
    id: `2`,
    name: `30,000,000 VND - 80,000,000 ${currencyEn}`,
    nameEn: `30,000,000 VND - 80,000,000 ${currencyEn}`,
  },
  {
    id: `3`,
    name: `81,000,000 VND - 150,000,000 ${currencyEn}`,
    nameEn: `81,000,000 VND - 150,000,000 ${currencyEn}`,
  },
  {
    id: `4`,
    name: `> 150,000,000 ${currencyEn}`,
    nameEn: `> 150,000,000 ${currencyEn}`,
  },
];

const source = [
  {
    id: 'SOURCE_SALARY',
    name: 'Lương',
    nameEn: 'Salary',
  },
  {
    id: 'SOURCE_BUSINESS',
    name: 'Kinh doanh',
    nameEn: 'Business Income',
  },
  {
    id: 'SOURCE_OTHER',
    name: 'Khác',
    nameEn: 'Other',
  },
];
const sourceEn = [
  {
    id: 'SOURCE_SALARY',
    name: 'Salary',
    nameEn: 'Salary',
  },
  {
    id: 'SOURCE_BUSINESS',
    name: 'Business',
    nameEn: 'Business',
  },
  {
    id: 'SOURCE_OTHER',
    name: 'Other',
    nameEn: 'Other',
  },
];
export const stringApp = {
  appName: 'iTRUST',
  appLink: 'iTRUST',
  companyName: 'DFVN',
  tellerCode: 'DFVN',
  riskAssessment: riskAssessment,
  riskAssessmentEn: riskAssessmentEn,
  source: source,
  sourceEn: sourceEn,
  monthlyIncom: monthlyIncom,
  monthlyIncomEn: monthlyIncomEn,
  currency: currency,
  currencyEn: currencyEn,
  versionApp: versionApp,
  hotline: support.hotline,
  phonesupport: support.phonesupport,
  emailsupport: support.emailsupport,
  Ext: support.Ext,
  gender: gender,
  notification,
};
